import RogoLogo from "../../assets/images/icon.svg";

export const LoadingComponent = () => {
	return (
		// load assets/images/icon.svg and make it spin
		<img
			id="rogoloader"
			src={RogoLogo}
			alt="Rogo Logo"
			// React 18 doesn't recognize the camelCase fetchPriority prop and warns
			// about it; lowercase passes through to the DOM untouched and is read
			// natively by Chromium. Cast keeps the TypeScript surface happy.
			{...({ fetchpriority: "high" } as Record<string, string>)}
			style={{
				animation: "spin 2s linear infinite",
			}}
			height={200}
			width={200}
		/>
	);
};
